// Verify Merchant
export const VERIFY_MERCHANT_REQUEST = 'VERIFY_MERCHANT_REQUEST';
export const VERIFY_MERCHANT_DONE = 'VERIFY_MERCHANT_DONE';
export const VERIFY_MERCHANT_FAILED = 'VERIFY_MERCHANT_FAILED';
export const VERIFY_MERCHANT_RESET = 'VERIFY_MERCHANT_RESET';